import { ReactElement } from 'react';

import { CameraIcon } from '@/lib/shared/icons/CameraIcon';
import { LogoIconSvg } from '@/lib/shared/icons/LogoIcon';
import { PlanIcon } from '@/lib/shared/icons/PlanIcon';
import { IClassname } from '@/lib/shared/model/classname';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import styles from './styles.module.scss';

import { Button } from '../../Buttons';

export interface GalleryGridProps extends IClassname {
  items: string[];
  onItemClick?: (item: string, index: number) => void;
  headerContent?: boolean;
  footerContent?: ReactElement;
  openModal: (initialSlide: number, initialTabIndex: number) => void;
}

export const GalleryGrid = ({
  items,
  onItemClick,
  headerContent,
  className,
  openModal,
}: GalleryGridProps) => {
  const { t } = useTranslation('index');
  const onClick = (item: string, index: number) => () => {
    if (onItemClick) {
      onItemClick(item, index);
    }
  };

  return (
    <div className={cn(styles.grid, className)}>
      {items.map(
        (item, index) =>
          item && (
            <figure
              key={item}
              className={styles.photo}
              onClick={onClick(item, index)}
            >
              <Image fill src={item} alt={''} />
              {index === 0 && (
                <>
                  {headerContent && (
                    <div className={styles.header}>
                      <div className={styles.header_tag}>
                        <LogoIconSvg />
                        <span>{t('rentPage.galleryTag')}</span>
                      </div>
                    </div>
                  )}

                  <div className={styles.footer}>
                    <div className={styles.buttons}>
                      <Button
                        as="button"
                        label={`${items.length} ${t('rentPage.photo')}`}
                        size="md"
                        theme="light"
                        icon={<CameraIcon />}
                        isIconLeft
                        onClick={() => openModal(0, 0)}
                      />
                      <Button
                        as="button"
                        label={t('layout')}
                        size="md"
                        theme="light"
                        icon={<PlanIcon />}
                        isIconLeft
                        onClick={() => openModal(0, 1)}
                      />
                    </div>
                  </div>
                </>
              )}
            </figure>
          )
      )}
    </div>
  );
};
